module.exports = __webpack_public_path__ + "static/media/gradestokk.e919b6a7.m4a";